var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('nav-bar',{attrs:{"activeId":0,"type":"1"}}),_c('div',{staticClass:"mainApp display u-flex u-row-center"},[_c('personal-left'),_c('router-view',{staticStyle:{"margin-left":"20px"}})],1),_c('tab-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }